var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__mariners--header"},[_c('funko-logo',{staticClass:"hide--below-lg"}),_c('main-navigation',{staticClass:"cz2__main-navigation-wrapper"}),_c('img',{staticClass:"cz2__mariners-pop-logo hide--below-lg",attrs:{"src":require("../assets/images/pop-yourself-logo.svg"),"alt":"Pop! Yourself Logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }